import { createReducer, on } from "@ngrx/store";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { PerguntaFrequenteOutputDto } from "src/app/domain/DTOs/output/pergunta-frequente.output.dto";
import { listarPerguntasFrequentes, listarPerguntasFrequentesFailure, listarPerguntasFrequentesFinish, listarPerguntasFrequentesSuccess } from "../actions/perguntas-frequentes.action";

export interface ListarPerguntasFrequentesState {
    response: EstruturaRetornoDadosOutputDto<PerguntaFrequenteOutputDto[]> | null;
    error: string[] | null;
}

export const initialState: ListarPerguntasFrequentesState = {
    response: null,
    error: null,
};

export const ListarPerguntasFrequentesReducer = createReducer(
    initialState,
    on(listarPerguntasFrequentes, state => ({ ...state, error: null })),
    on(listarPerguntasFrequentesSuccess, (state, { response }) => ({ ...state, response, error: null })),
    on(listarPerguntasFrequentesFailure, (state, { response }) => ({ ...state, response: null, error: response.erros })),
    on(listarPerguntasFrequentesFinish, state => ({ ...state, response: null, error: null }))
);
